import $ from '@vaersaagod/tools/Dom';
import Viewport from '@vaersaagod/tools/Viewport';
import Flickity from 'flickity';

export default (el, props) => {
    const dom = $(el);
    const wrapper = dom.find('[data-slides]').get(0);
    const slides = dom.find('[data-slide]');
    const prev = dom.find('[data-prev]');
    const next = dom.find('[data-next]');
    let flkty = null;

    const initFlickity = () => {
        flkty = new Flickity(wrapper, {
            contain: true,
            dragThreshold: 15,
            cellAlign: 'left',
            prevNextButtons: false,
            pageDots: false,
            freeScroll: true,
            freeScrollFriction: 0.045
        });
        flkty.resize();

        flkty.on('dragStart', () => {
            document.ontouchmove = e => e.preventDefault();
        });

        flkty.on('dragEnd', () => {
            document.ontouchmove = () => true;
        });

        flkty.on('change', () => {
            prev.attr('disabled', flkty.selectedIndex > 0 ? null : '');
            next.attr('disabled', flkty.selectedIndex < (flkty.slides.length - 1) ? null : '');
        });

        prev.on('click', e => {
            flkty.previous();
        });

        next.on('click', e => {
            flkty.next();
        });

        slides.on('focus', e => {
            const slide = $(e.target);
            flkty.select(Number(slide.data('slide')));
        });
    };

    const destroyFlickity = () => {
        if (flkty) {
            flkty.destroy();
            flkty = null;
        }
    };

    const resize = () => {
        if (Viewport.width < props.cutoff && !flkty) {
            initFlickity();
        } else if (Viewport.width >= props.cutoff && flkty) {
            destroyFlickity();
        }
    };

    const init = () => {
        if (props && props.cutoff) {
            Viewport.on('resize', resize);
            resize();
        } else {
            initFlickity();
        }
    };

    const destroy = () => {
        destroyFlickity();
        Viewport.off('resize');
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/Slider.js